import { Label } from "@dgs/core";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
	ContactUpdateAddressDiffEntryResource,
	ContactUpdateCompanyDiffEntryResource,
	ContactUpdateEmailDiffEntryResource,
	ContactUpdatePhoneDiffEntryResource,
} from "../../../../shared/types/contactUpdateInquiry";
import { ContactUpdateBaseDiffCard } from "./ContactUpdateBaseDiffCard";

export function mapRelationEntry(
	entry:
		| ContactUpdateEmailDiffEntryResource
		| ContactUpdatePhoneDiffEntryResource
		| ContactUpdateCompanyDiffEntryResource
		| ContactUpdateAddressDiffEntryResource,
) {
	return {
		isNew: entry.isNew,
		isPrimary: entry.isPrimary,
		shouldBeRemoved: entry.shouldBeRemoved,
		type: entry.type,
	};
}

export interface ContactUpdateInquiryDiffEntry {
	heading: string;
	value: ReactNode;
	onClick: () => void;
	type: string | undefined;
	isPrimary: boolean;
	isNew: boolean;
	shouldBeRemoved: boolean;
	active: boolean;
}

export interface BaseRelContactUpdateInquiryBaseRelationRowProps {
	currentContact: ContactUpdateInquiryDiffEntry;
	updatedContact: ContactUpdateInquiryDiffEntry;
}

export const ContactUpdateBaseRelationDiffRow: FC<BaseRelContactUpdateInquiryBaseRelationRowProps> = ({
	currentContact,
	updatedContact,
}) => {
	const { t } = useTranslation();

	return (
		<>
			<ContactUpdateBaseDiffCard
				onClick={currentContact.onClick}
				active={currentContact.active}
				heading={currentContact.heading}
				value={updatedContact.isNew ? "-" : currentContact.value}
				labels={
					!updatedContact.isNew && (
						<>
							{currentContact.type && <Label size="small">{t(currentContact.type)}</Label>}
							{currentContact.isPrimary && (
								<Label size="small" color="primary">
									{t("Primary")}
								</Label>
							)}
						</>
					)
				}
			/>
			<ContactUpdateBaseDiffCard
				onClick={updatedContact.onClick}
				active={updatedContact.active}
				heading={updatedContact.heading}
				value={currentContact.shouldBeRemoved ? "-" : updatedContact.value}
				labels={
					<>
						{currentContact.shouldBeRemoved && (
							<Label size="small" color="danger">
								{t("Remove")}
							</Label>
						)}
						{!currentContact.shouldBeRemoved && (
							<>
								{updatedContact.type && <Label size="small">{t(updatedContact.type)}</Label>}
								{updatedContact.isPrimary && (
									<Label size="small" color="primary">
										{t("Primary")}
									</Label>
								)}
								{updatedContact.isNew && (
									<Label size="small" color="warning">
										{t("New")}
									</Label>
								)}
							</>
						)}
					</>
				}
			/>
		</>
	);
};
